import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FormImportErrorRow } from "Backend";

interface ImportErrorsProps {
  errors: FormImportErrorRow[];
}

export default function ProfileImportErrorTable({ errors }: ImportErrorsProps) {
  return (
    <TableContainer sx={{ maxHeight: 640 }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ whiteSpace: "nowrap" }}>Case ID</TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>Row Number</TableCell>
            <TableCell sx={{ whiteSpace: "nowrap" }}>Errors</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {errors.map((error, index) => (
            <TableRow key={index}>
              <TableCell>{error.clientCaseId}</TableCell>
              <TableCell>{error.rowNumber === 0 ? "Header" : error.rowNumber}</TableCell>
              <TableCell>{error.errors.join(", ")}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
